module.exports = __webpack_public_path__ + "img/6.ed46d6e7.jpg";